import {Grid, Loader, Typography} from '@logistics-frontend/blocks'
import React, {memo} from 'react'

import {i18n} from 'src/shared/config'

import * as classes from './NoOffersPlaceholder.classes'

type Props = {
  isPending?: boolean
  isValid?: boolean
}

export const NoOffersPlaceholder = memo<Props>(function NoOffersPlaceholder({isValid = true, isPending = false}) {
  return (
    <Grid alignItems="center" className={classes.root} direction="column" container>
      <Grid item>
        {isPending ? (
          <Loader fullWidth />
        ) : (
          <Typography color={isValid ? 'main' : 'error'} group="normal" thickness="regular" variant="body2">
            {i18n('order.offers.empty', 'Нет подходящих вариантов')}
          </Typography>
        )}
      </Grid>
    </Grid>
  )
})
